import { StyleSheet } from 'react-native';
import { ThemeColors } from '../../../common/theme-colors';
import theme from '../../../common/theme';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      width: 220,
      height: 362,
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: theme.radius.l,
      backgroundColor: colors.elevation0,
      overflow: 'hidden',
    },
    image: {
      width: 220,
      height: 220,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.elevation1,
    },
    text: {
      rowGap: 8,
      padding: 20,
    },
    name: {
      fontSize: 16,
      lineHeight: 22,
      color: colors.text,
      fontFamily: theme.fonts.medium,
      fontVariant: ['tabular-nums'],
    },
    desc: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.textLight,
      fontFamily: theme.fonts.regular,
      fontVariant: ['tabular-nums'],
    },
    price: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.text,
      fontFamily: theme.fonts.medium,
      fontVariant: ['tabular-nums'],
    },
    badge: {
      paddingVertical: 6,
      paddingHorizontal: 12,
      borderRadius: theme.radius.s,
      backgroundColor: colors.green,
      position: 'absolute',
      top: 12,
      right: 12,
      zIndex: 1,
    },
    badgeText: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.white,
      fontVariant: ['tabular-nums'],
      fontFamily: theme.fonts.regular,
    },
  });
